// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".createTableTimePerMove_radioGroup__2KNwB {\n  margin-top: 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}", ""]);
// Exports
exports.locals = {
	"radioGroup": "createTableTimePerMove_radioGroup__2KNwB"
};
module.exports = exports;
